// TestYourKnowledgeItemCard.jsx
import React from "react";
import { Card, CardBody, CardHeader, CardGroup } from "../card/card.jsx";
import VoiceoverCard from "../VoiceoverCard/VoiceoverCard.js";
import ImageCard from "../ImageCard/ImageCard.js"; // adjust the import path as needed
import QuizNavigation from "../QuizNavigation/QuizNavigation.js";
import "./custom-checkbox.css";

const TestYourKnowledgeItemCard = ({
  index,
  item,
  currentIndex,
  quizStructure,
  setCurrentIndex,
  updateField, // function to update a field; caller provides dispatch-based updater
  generateAnswerVoice,
  updatePreImageField,
  updatePostImageField,
  shortcutModifier,
}) => {
  return (
    <Card>
      <CardHeader>
        <h5>Test Your Knowledge – Item {index + 1}</h5>
      </CardHeader>
      <CardBody>
        <QuizNavigation
            currentIndex={currentIndex}
            totalItems={quizStructure.items.length}
            onPrevious={() =>
                setCurrentIndex((prev) => Math.max(0, prev - 1))
            }
            onNext={() =>
                setCurrentIndex((prev) =>
                    Math.min(quizStructure.items.length, prev + 1)
                )
            }
        />
        {/* Question Input */}
        <Card>
          <CardHeader>
            <h5>Question</h5>
          </CardHeader>
          <CardBody>
          <input
            type="text"
            className="form-control"
            value={item.question.text}
            onChange={(e) =>
              updateField(index, "UPDATE_QUESTION_TEXT", { text: e.target.value })
            }
            placeholder="Enter the trivia question"
          />
          </CardBody>
        </Card>

        {/* Options */}
        <Card>
            <CardHeader>
                <h5>Options</h5>
            </CardHeader>
            <CardBody>
                <CardGroup>
                {["option1", "option2", "option3"].map((optKey, idx) => (
                    <Card key={optKey} className="mb-2">
                    <CardHeader>
                        <label className="form-label">{`Option ${idx + 1}`}</label>
                    </CardHeader>
                    <CardBody>
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        className="form-control flex-grow-1"
                        value={item[optKey].text}
                        onChange={(e) =>
                          updateField(index, "UPDATE_OPTION_TEXT", {
                            optionKey: optKey,
                            text: e.target.value,
                          })
                        }
                        placeholder="Enter option text"
                      />
                      <input
                        type="checkbox"
                        className="ms-2 custom-checkbox"
                        checked={item[optKey].isCorrect}
                        onChange={(e) =>
                          updateField(index, "UPDATE_OPTION_ISCORRECT", {
                            optionKey: optKey,
                            isCorrect: e.target.checked,
                          })
                        }
                        title="Mark as correct answer"
                      />
                    </div>

                        </CardBody>
                    </Card>
                ))}
                </CardGroup>
            
            </CardBody>
        </Card>
        {/* Answer Voiceover */}
        <div className="mb-3">
          <VoiceoverCard
            label="Answer Voiceover"
            voiceover={item.answer}
            onTextChange={(text) =>
              updateField(index, "UPDATE_ANSWER_TEXT", { text })
            }
            onGenerateVoice={() => generateAnswerVoice(index)}
            shortcutModifier={shortcutModifier}
          />
        </div>

        {/* Pre Image Card */}
        <div className="mb-3">
          <ImageCard
            label="Pre-Image (Visual Hint)"
            imageData={item.preImage}
            onPromptChange={(value) =>
              updatePreImageField(index, "prompt", value)
            }
            onQueryChange={(value) =>
              updatePreImageField(index, "query", value)
            }
            onImagesGenerated={(images) =>
              updatePreImageField(index, "images", images, true)
            }
            onImageSelect={(image) =>
              updatePreImageField(index, "selection", image)
            }
            uniqueId={`preimage-${index}`}
            shortcutModifier={shortcutModifier}
          />
        </div>

        {/* Post Image Card */}
        <div className="mb-3">
          <ImageCard
            label="Post-Image (Answer Visualization)"
            imageData={item.postImage}
            onPromptChange={(value) =>
              updatePostImageField(index, "prompt", value)
            }
            onQueryChange={(value) =>
              updatePostImageField(index, "query", value)
            }
            onImagesGenerated={(images) =>
              updatePostImageField(index, "images", images, true)
            }
            onImageSelect={(image) =>
              updatePostImageField(index, "selection", image)
            }
            uniqueId={`postimage-${index}`}
            shortcutModifier={shortcutModifier}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default TestYourKnowledgeItemCard;
